import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SettingsShell } from '@/features/app-shell';
import { FeatureErrorBoundary } from '@/shared/components/FeatureErrorBoundary';

export const Route = createFileRoute('/settings')({
  component: SettingsLayoutRoute,
});

/** The person's own settings (spec 142), beside `/workspaces` and `/admin`. */
export function SettingsLayoutRoute() {
  return (
    <SettingsShell>
      <FeatureErrorBoundary>
        <Outlet />
      </FeatureErrorBoundary>
    </SettingsShell>
  );
}
